import { makeAutoObservable, runInAction } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export default class ChargeStore {
	constructor() {
		makeAutoObservable(this);
		makePersistable(this, {
			name: 'ChargeStore',
			properties: [
				'charges',
			],
		});
	}

	charges = [];

	reset = () => {
		this.charges = [];
	};

	setCharges = async state => {
		runInAction(() => {
			this.charges = state;
		});
	};
}